import { RESOURCES } from '@shared/Resources/types';
export const DEFAULT_TYPE = RESOURCES.MEDIA;

export const SOURCE_TYPE = {
  DELETE: 'delete',
  COPY: 'copy',
  DUPLICATE: 'duplicate',
}
